import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/subscription/subscription";

export default class SubscriptionService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
